
import { supabase } from '@/integrations/supabase/client';
import { deleteProjectMaterials, deleteProjectLabor } from './resourceHelpers';
import { dataRefresh } from '@/lib/dataRefresh';

// Delete a project
export const deleteProject = async (id: string): Promise<boolean> => {
  try {
    // Delete related materials first
    await deleteProjectMaterials(id);
    
    // Delete related labor
    await deleteProjectLabor(id);
    
    // Now delete the project
    const { error } = await supabase
      .from('projects')
      .delete()
      .eq('id', id);
    
    if (error) {
      console.error('Error deleting project:', error);
      return false;
    }
    
    // Trigger refresh for projects, materials, and labors
    await dataRefresh.triggerMultiple(['projects', 'materials', 'labors']);
    
    return true;
  } catch (error) {
    console.error('Error deleting project:', error);
    return false;
  }
};
